import { sendToGTM } from '@elgorditosalsero/react-gtm-hook'
import sha256 from 'crypto-js/sha256'

/**
 * Push user data to GTM dataLayer (mirrors winkit PushUserDataToGtm).
 */
export const PushUserDataToGtm = (eventName, user, appUrl, value = null, jobId = null) => {
	try {
		let customerDataHashed = {}
		if (user) {
			const phoneStrippedPlus = user?.customer?.phoneNumber?.replace(/\+/g, '')
			customerDataHashed = {
				id: sha256(user?.customer?.id || user?.id).toString() || 'guest_user',
				firstName: sha256(user?.firstName).toString() || 'guest_user',
				lastName: sha256(user?.lastName).toString() || 'guest_user',
				email: sha256(user?.email).toString() || 'guest_user',
				phone: sha256(phoneStrippedPlus).toString() || 'guest_user',
				...(jobId ? { jobId: jobId.toString() } : {}),
			}
		}
		// console.log('[GTM-TRACK] customerDataHashed', customerDataHashed)
		const gtmDataObj = {
			event: eventName,
			environment: appUrl,
			value,
			...customerDataHashed,
		}
		window.dataLayer = window.dataLayer || []
		sendToGTM({ dataLayerName: 'dataLayer', data: gtmDataObj })
	} catch (err) {
		console.error(`Data for ${eventName} can't be pushed to frontend GTM dataLayer`, err)
	}
}

/**
 * Fixed-hour project conversion value at approval time.
 */
export const getProjectConversionValue = (job, longJobCost, discountedCost) => {
	const baseCost = Number(longJobCost) || Number(job?.long_job_cost) || 0
	if (discountedCost && discountedCost !== 0 && discountedCost !== baseCost) {
		return parseFloat(Number(discountedCost).toFixed(2))
	}
	return parseFloat(baseCost.toFixed(2)) || 0
}

/**
 * Pushes project conversion GTM events once per job when a customer approves a fixed-hour project.
 * Skips if already tracked (GA_revenue_event_called) or not applicable. Persists the flag after push.
 */
export async function trackProjectConversionGtmOnce({
	job,
	user,
	longJobCost,
	discountedCost,
	meetingWithMinutes,
	appUrlBase,
	updateJobFn,
}) {
	if (user?.userType !== 'customer' || meetingWithMinutes) {
		return
	}
	if (!process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
		return
	}
	if (job?.GA_revenue_event_called === 'yes') {
		return
	}
	const appUrl = (appUrlBase || '').split('/')[2] || false
	if (!appUrl) {
		return
	}
	const conversionValue = getProjectConversionValue(job, longJobCost, discountedCost)
	console.log('[GTM-TRACK]', { event: 'project_approved', page: 'LongJobDetails', jobId: job?.JobId, conversionValue })
	// PushUserDataToGtm('project_approved', user, appUrl, conversionValue, job?.JobId)
	// console.log('[GTM-TRACK]', { event: 'job_ended', page: 'LongJobDetails', jobId: job?.JobId, conversionValue })
	// PushUserDataToGtm('job_ended', user, appUrl, conversionValue, job?.JobId)
	if (updateJobFn && job?.id) {
		await updateJobFn(job.id, {
			dataToUpdate: { GA_revenue_event_called: 'yes' },
			cuId: user?.id,
		})
	}
}
